import { Brain, Gamepad2, Plane, GraduationCap, Mail, LucideIcon } from 'lucide-react';

export type DivisionKey = 'ai' | 'game' | 'avionics' | 'teach';

export interface Division {
  key: DivisionKey;
  /** Route path, e.g. /ai */
  path: string;
  /** CSS modifier used to swap the accent gradient */
  accent: string;
  icon: LucideIcon;
  /** translation keys */
  nameKey: string;
  taglineKey: string;
  pitchKey: string;
  badgeKey: string;
  featureKeys: [string, string, string];
  navKey: string;
}

export interface NavItem {
  key: string;
  path: string;
  accent: string;
  icon: LucideIcon;
  nameKey: string;
  navKey: string;
}

export const DIVISIONS: Division[] = [
  {
    key: 'ai',
    path: '/ai',
    accent: 'accent-ai',
    icon: Brain,
    nameKey: 'ai.name',
    taglineKey: 'ai.tagline',
    pitchKey: 'ai.pitch',
    badgeKey: 'ai.badge',
    featureKeys: ['ai.f1', 'ai.f2', 'ai.f3'],
    navKey: 'nav.ai',
  },
  {
    key: 'game',
    path: '/gamedev',
    accent: 'accent-game',
    icon: Gamepad2,
    nameKey: 'game.name',
    taglineKey: 'game.tagline',
    pitchKey: 'game.pitch',
    badgeKey: 'game.badge',
    featureKeys: ['game.f1', 'game.f2', 'game.f3'],
    navKey: 'nav.gamedev',
  },
  {
    key: 'avionics',
    path: '/avionics',
    accent: 'accent-avionics',
    icon: Plane,
    nameKey: 'avionics.name',
    taglineKey: 'avionics.tagline',
    pitchKey: 'avionics.pitch',
    badgeKey: 'avionics.badge',
    featureKeys: ['avionics.f1', 'avionics.f2', 'avionics.f3'],
    navKey: 'nav.avionics',
  },
  {
    key: 'teach',
    path: '/teachandlearn',
    accent: 'accent-teach',
    icon: GraduationCap,
    nameKey: 'teach.name',
    taglineKey: 'teach.tagline',
    pitchKey: 'teach.pitch',
    badgeKey: 'teach.badge',
    featureKeys: ['teach.f1', 'teach.f2', 'teach.f3'],
    navKey: 'nav.teach',
  },
];

export const NAV_ITEMS: NavItem[] = [
  ...DIVISIONS.map((d) => ({
    key: d.key,
    path: d.path,
    accent: d.accent,
    icon: d.icon,
    nameKey: d.nameKey,
    navKey: d.navKey,
  })),
  {
    key: 'contact',
    path: '/contact',
    accent: 'accent-contact',
    icon: Mail,
    nameKey: 'contact.name',
    navKey: 'nav.contact',
  },
];

export const YOUTUBE_GAMEDEV = 'https://www.youtube.com/@skycode.gamedev';
export const CONTACT_EMAIL = 'skycode.gamedev@gmail.com';
